import moment from 'moment';
import { Row, Col, Button, Form, Modal, message } from 'antd';
import Icon from "@mdi/react";
import { mdiArrowLeft } from "@mdi/js";
import { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useLocation } from "react-router";
import environment from "../../../../../config/environment";
import OTPInput from "../../../../widget/otpInput";
import imgOtp from "../../../../../assets/images/ndid/logo-OTP.png";
import { i18n } from '../../../../../i18n/i18n';
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../../i18n/i18n.constants";
import { format } from 'util';
import { useTimer } from 'react-timer-hook';
import { any } from 'prop-types';
import alert from "../../../../../assets/images/ndid/alert.png";
import done from "../../../../../assets/images/ndid/done.png";
import iconNext from "../../../../../assets/images/icon/next-arrow.svg";

const OtpNdidPage = () => {
  const location: any = useLocation()
  const history = useHistory();
  const [isTimerOut, setTimerOut] = useState(false);
  const [valueOtp, setValueOtp] = useState("");
  const [textNumber, setTextNumber] = useState("");
  const [dataOtp, setDataOtp] = useState<any>({})
  const [expiryTimestamp, setexpiryTimestamp] = useState(new Date());
  const { restart } = useTimer({ expiryTimestamp });
  const [isTimer, setTimer] = useState(new Date());
  const [onChangeOtp, setOnChangeOtp] = useState("");
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation(namespaces.pages.daolinvNdid);

  function MyTimer({ expiryTimestamp }) {
    const {
      seconds,
      minutes,
      isRunning,
    } = useTimer({ expiryTimestamp, onExpire: () => setTimerOut(true) });

    return (
      <div>
        <p>{isRunning ? (<span>{minutes}{`:`}{seconds}</span>) : ('0:0')}</p>
      </div>
    );
  }

  const genOTP = async () => {
    const urlMobile = `${environment?.baseApi}/sent`
    axios.post(urlMobile, {
      senderName: "DAOL-INV",
      phoneNumber: location?.state?.mobile,
      lang: i18n.language === "th" ? "TH" : "EN",
      vendorCode: environment?.imNDIDCode,
    })
      .then(res => {
        // console.log('genOTP', res.status)
        if (res.status === 200) {
          setDataOtp(res.data);
          setLoading(false);
        } else {
          Modal.error({
            icon: <img src={alert} className="img-popup" alt="alert" />,
            title: t("popup_login_error_title"),
            content: t("popup_login_error_content_mobile"),
            okText: t("btn_again"),
            onOk() { },
          });
        }

      }).catch((error) => {
        Modal.error({
          title: t("popup_error500_title"),
          content: t("popup_error500_content"),
          icon: '',
          onOk() {
          },
        });
        console.error('catch error', error);
      });
  };

  const resendOtp = async () => {
    await genOTP();
    const time = new Date();
    time.setSeconds(time.getSeconds() + 180);
    setTimer(time);
    restart(time);
    setTimerOut(false);

  };
  const calculateTimeLeft = async () => {
    // console.log('calculateTimeLeft>>>', location?.state?.mobile)
    if (location?.state?.mobile !== 'undefined') {
      let text = location?.state?.mobile;
      let result = text.substring(0, 6);
      setTextNumber(result);
      await genOTP();
    }
  };

  const onSubmitOTP = async () => {
    const urlValidate = `${environment?.baseApi}/ndid-validate-otp`
    let urlValidateSaNdid = ``
    setLoading(true);
    axios.post(urlValidate, {
      senderName: "DAOL-INV",
      phoneNumber: dataOtp?.data?.phoneNumber,
      refCode: dataOtp?.data?.refCode,
      otp: onChangeOtp,
      customerId: location?.state?.id,
      vendorCode: environment?.imNDIDCode,
    })
      .then(res => {
        console.log('res.data', res.data);
        
        setOnChangeOtp("");
        setLoading(false);
        if (res.data === "0002") {
          Modal.error({
            icon: <img src={alert} className="img-popup" alt="alert" />,
            title: t("popup_otp_error_title"),
            content: (<><div>{t("popup_otp_error_content")}</div><div>{t("popup_error_content")}</div></>),
            okText: t("btn_again"),
            onOk() {
              // console.log('OnOKay');
              setOnChangeOtp("");
            },
          });
          setOnChangeOtp("");
          setLoading(false);
        } else if (res.data === "0006") {
          Modal.error({
            icon: <img src={alert} className="img-popup" alt="alert" />,
            title: t("popup_otp_error_title"),
            content: (<><div>{t("popup_otp_lock_content")}</div></>),
          });
          setOnChangeOtp("");
          setLoading(false);
        } else {
          setTimerOut(false);
          setLoading(false);

          if (location?.state?.token !== 'undefined' && location?.state?.token !== '') {
            urlValidateSaNdid += `token=${location?.state?.token}`
          }
          if (location?.state?.identifier !== 'undefined' && location?.state?.identifier !== '') {
            urlValidateSaNdid += `&identifier=${location?.state?.identifier}`
          }
          if (location?.state?.ndid_phase !== 'undefined' && location?.state?.ndid_phase !== '') {
            urlValidateSaNdid += `&ndid_phase=${location?.state?.ndid_phase}`
          }
          window.location.href = `${environment?.ndidInvApi}${urlValidateSaNdid}`;
        }
      }).catch((error) => {
        console.error(error);
      });
  };


  useEffect(() => {
    setLoading(false);
    calculateTimeLeft();
    const time = new Date();
    time.setSeconds(time.getSeconds() + 180);
    // // time.setSeconds(time.getSeconds() + 20);
    setTimer(time);
    setTimerOut(false);
  }, [location]);



  return (
    <>
      <div className="home-page mainndid-page">
        {/*{console.log('StateStateState', location?.state?.phone)}
        {console.log('timetimetime', isTimerOut)}
        {console.log('expiryTimestamp', expiryTimestamp)} */}
        {isLoading === true ?
          <div className="sping-loading">
            <div className="loading"></div>
            <p>{t("loading")}</p>
          </div> : ""}
        <div className="container">
          <Row className="container-main daol-ndid">
            <div className="content-right col-sm-8 text-center">
              {/* <p><img src={imgOtp} alt="image_otp" /></p> */}
              <Form
                name="normal_otp"
                className="otpndid-form"
                initialValues={{ remember: true }}
                onFinish={onSubmitOTP}
              >
                <p>{t("otp_descrip_p1")} {textNumber}xxxx</p>
                <p className="remark">{t("otp_remark")}</p>
                <div className="container-from">

                  <Form.Item
                    name="otp"
                    className="from-otp"
                  >
                    <OTPInput
                      autoFocus
                      length={6}
                      className="otp-group"
                      inputClassName="otpInput"
                      onChangeOTP={setOnChangeOtp}
                    />
                  </Form.Item>
                  <Row className="refer-otp">
                    <Col span={12} className="text-left">{t("otp_refCode")} {dataOtp?.data?.refCode}</Col>
                    <Col span={12} className="text-right">
                      <MyTimer expiryTimestamp={isTimer} />
                    </Col>
                  </Row>
                </div>

                <Form.Item className="container-button btn-ndid">
                  <p>
                    {isTimerOut === true ? (
                      <Button onClick={async e => { await resendOtp() }}>
                        {t("btn_otp")}
                      </Button>
                    ) : ""}

                  </p>
                  {console.log('isTimerOut ', isTimerOut)}
                  {console.log('onChangeOtp ===', onChangeOtp.length)}


                  {onChangeOtp.length === 6 && isTimerOut === false ? (
                    <Button type="primary" className="btn-next" htmlType="submit">
                      {t("btn_next")} <img src={iconNext} alt="icon-next" />
                    </Button>) : isTimerOut === true ? (
                      <Button type="primary" className="btn-next" disabled>
                        {t("btn_next")} <img src={iconNext} alt="icon-next" />
                      </Button>) : (
                    <Button type="primary" className="btn-next" disabled>
                      {t("btn_next")} <img src={iconNext} alt="icon-next" />
                    </Button>)}

                </Form.Item>
              </Form>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};
export default OtpNdidPage;
